<script setup>
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
  isLiveChatType: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  'edit',
  'delete',
  'duplicate',
  'viewReport',
  'viewDetails',
]);

const handleEdit = campaign => emit('edit', campaign);
const handleDelete = campaign => emit('delete', campaign);
const handleDuplicate = campaign => emit('duplicate', campaign);
const handleViewReport = campaign => emit('viewReport', campaign);
const handleViewDetails = campaign => emit('viewDetails', campaign);
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :title="campaign.title"
      :message="campaign.message"
      :is-enabled="campaign.enabled"
      :status="campaign.campaign_status"
      :sender="campaign.sender"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :is-live-chat-type="isLiveChatType"
      :is-whats-app-type="campaign.inbox?.channel_type === 'Channel::Whatsapp'"
      :metrics="campaign.metrics"
      @edit="handleEdit(campaign)"
      @delete="handleDelete(campaign)"
      @duplicate="handleDuplicate(campaign)"
      @view-report="handleViewReport(campaign)"
      @view-details="handleViewDetails(campaign)"
    />
  </div>
</template>
